import React from 'react';
import { getModeConfig } from '../../utils/timerManager';

const QuizModeBadge = ({ mode, onClick, showLabel = true }) => {
  const config = getModeConfig(mode);

  return (
    <div 
      className={`quiz-mode-badge ${onClick ? 'clickable' : ''}`}
      onClick={onClick}
      style={{ 
        background: config.color,
        cursor: onClick ? 'pointer' : 'default'
      }}
      title={`${config.name} - ${config.description}`}
    >
      <span className="quiz-mode-badge-icon">{config.icon}</span>
      {showLabel && (
        <span className="quiz-mode-badge-text">{config.name}</span>
      )}
    </div>
  );
};

export default QuizModeBadge;
